import type { ToastWrapperInstance } from 'vant/lib/toast/types'
import { showFailToast, showLoadingToast, showSuccessToast } from 'vant'

export function successToast(message: string = 'Success'): void {
  showSuccessToast(message)
}

export function errorToast(message: string = 'Error'): void {
  showFailToast(message)
}

export function loadingToast(message: string = 'Loading...', forbidClick: boolean = true, duration: number): ToastWrapperInstance {
  return showLoadingToast({ message, forbidClick, duration })
}
